/** @module csi/view/ToolbarPluginButton */
define([
	"dojo/_base/declare",
	"dijit/form/Button",
	"./ToolbarPlugin"
], function(declare,Button,ToolbarPlugin) {

	return declare([Button, ToolbarPlugin],	{
		/**
		 * Set appearance based on action
		 */
		postMixInProperties: function() {
			this._mixinActionProperties();
			this.inherited(arguments);
		},
		
		/**
		 * Do not instantiate buttons when printing
		 */
		validatePlugin: function(ctx) {
			return !ctx.bPrint;
		}
	});
});